import React from 'react';

const IconLeHamburger = ({ mode = 'light' }) => (
  <svg width="21" height="15" viewBox="0 0 21 15" xmlns="http://www.w3.org/2000/svg">
    <g fill={mode === 'light' ? '#3D4D5C' : '#FFFFFF'} fillRule="evenodd">
      <rect width="21" height="2.5" rx="1.25" />
      <rect y="6" width="21" height="2.5" rx="1.25" />
      <rect y="12" width="21" height="2.5" rx="1.25" />
    </g>
  </svg>
);

export default IconLeHamburger;
